import { provide, ref } from 'vue-demi';
export var useInjectionCleaner = function (injectionKeys) {
    injectionKeys.forEach(function (key) { return provide(key, ref()); });
};
//# sourceMappingURL=useInjectionCleaner.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/hooks/useInjectionCleaner.js
// module id = null
// module chunks = 